import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PrintSetlists from "./PrintSetlists";
import AdminMenu from './adminMenu';
import "../css/Songlist.css";
const Setlist = ({ setIsAuthenticated }) => {
    const [masterSongs, setMasterSongs] = useState([]);
    const [setlist, setSetlist] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [setlistId, setSetlistId] = useState(1);
    const [showPreview, setShowPreview] = useState(false);

    const [newArtist, setNewArtist] = useState("");
    const [newSongTitle, setNewSongTitle] = useState("");
    const [addingSong, setAddingSong] = useState(false);

    const [printSetlists, setPrintSetlists] = useState({
        setlist1: [],
        setlist2: [],
        setlist3: [],
    });
    const [loadingPrintSetlists, setLoadingPrintSetlists] = useState(false);

    const API_BASE_URL = ""; // same-origin so the login cookie is sent

    const setlistOptions = {
        1: "Set 1",
        2: "Set 2",
        3: "Set 3",
    };

    // Load master songs + current setlist
    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                // Fetch all setlists
                const [songsRes, setlist1Res, setlist2Res, setlist3Res, currentSetlistRes] = await Promise.all([
                    fetch(`${API_BASE_URL}/api/songlist`),
                    fetch(`${API_BASE_URL}/api/setlist?setlistId=1`),
                    fetch(`${API_BASE_URL}/api/setlist?setlistId=2`),
                    fetch(`${API_BASE_URL}/api/setlist?setlistId=3`),
                    fetch(`${API_BASE_URL}/api/setlist?setlistId=${setlistId}`),
                ]);

                const songsData = await songsRes.json();
                const setlist1 = await setlist1Res.json();
                const setlist2 = await setlist2Res.json();
                const setlist3 = await setlist3Res.json();
                const currentSetlist = await currentSetlistRes.json();

                setMasterSongs(
                    songsData.filter(
                        (song) =>
                            ![...setlist1, ...setlist2, ...setlist3].some(
                                (s) => s.songTitle === song.songTitle && s.artist === song.artist
                            )
                    )
                );
                setPrintSetlists({ setlist1, setlist2, setlist3 });
                setSetlist(currentSetlist);
                setLoading(false);
            } catch (err) {
                console.error(err);
                setError("Failed to load songs or setlists.");
                setLoading(false);
            }
        };
        fetchData();
    }, [API_BASE_URL, setlistId]);


    const addSongToMasterList = async (e) => {
        e.preventDefault();
        if (!newSongTitle.trim()) {
            alert("Song title cannot be empty.");
            return;
        }

        setAddingSong(true);
        const newSong = {
            artist: newArtist.trim() || "Unknown Artist",
            songTitle: newSongTitle.trim(),
        };

        try {
            const response = await fetch(`${API_BASE_URL}/api/songlist`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(newSong),
            });

            if (!response.ok) throw new Error("Failed to add new song");

            const savedSong = await response.json();
            setMasterSongs((prev) => [...prev, savedSong]);
            setNewArtist("");
            setNewSongTitle("");
        } catch (err) {
            console.error("Failed to add new song", err);
            alert("Error adding new song to master list.");
        } finally {
            setAddingSong(false);
        }
    };

    const onDragEnd = async (result) => {
        const { source, destination } = result;
        if (!destination) return;

        if (source.droppableId === "masterList" && destination.droppableId === "setlist") {
            const song = masterSongs[source.index];

            // Prevent duplicates in current setlist
            const alreadyInSetlist = setlist.some(
                (s) => s.songTitle === song.songTitle && s.artist === song.artist
            );
            if (alreadyInSetlist) {
                alert(`"${song.songTitle}" by ${song.artist} is already in this setlist.`);
                return;
            }

            const newItem = {
                artist: song.artist || "Unknown Artist",
                songTitle: song.songTitle,
                tracks: false,
                order: destination.index,
            };

            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/setlist?setlistId=${setlistId}`,
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(newItem),
                    }
                );

                if (!response.ok) throw new Error("Failed to add song to setlist");

                const savedItem = await response.json();

                // Add to setlist
                const newSetlist = Array.from(setlist);
                newSetlist.splice(destination.index, 0, savedItem);
                setSetlist(newSetlist);

                // Remove from masterSongs
                const newMasterSongs = Array.from(masterSongs);
                newMasterSongs.splice(source.index, 1);
                setMasterSongs(newMasterSongs);

            } catch (err) {
                console.error("Failed to save new song to setlist", err);
                alert("Error adding song to setlist.");
            }
            return;
        }

        if (source.droppableId === "setlist" && destination.droppableId === "setlist") {
            const reordered = Array.from(setlist);
            const [moved] = reordered.splice(source.index, 1);
            reordered.splice(destination.index, 0, moved);
            setSetlist(reordered);

            try {
                await fetch(`${API_BASE_URL}/api/setlist/reorder?setlistId=${setlistId}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(
                        reordered.map((song, index) => ({ id: song.id, order: index }))
                    ),
                });
            } catch (err) {
                console.error("Failed to save new order", err);
                alert("Error saving new song order.");
            }
        }
    };

    const removeFromSetlist = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/setlist/${id}`, {
                method: "DELETE",
            });
            if (!response.ok) throw new Error("Failed to remove song from setlist");
            setSetlist((prev) => prev.filter((song) => song.id !== id));
        } catch (error) {
            console.error(error);
            alert("Error removing song from setlist");
        }
    };

    const toggleTrack = async (id) => {
        const updatedSetlist = setlist.map((song) =>
            song.id === id ? { ...song, tracks: !song.tracks } : song
        );
        setSetlist(updatedSetlist);

        const updatedSong = updatedSetlist.find((s) => s.id === id);
        try {
            await fetch(`${API_BASE_URL}/api/setlist/${id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updatedSong),
            });
        } catch (err) {
            console.error("Failed to update track status", err);
            alert("Error updating track status.");
        }
    };

    const fetchPrintSetlists = async () => {
        setLoadingPrintSetlists(true);
        try {
            const results = await Promise.all([
                fetch(`${API_BASE_URL}/api/setlist?setlistId=1`).then((res) => res.json()),
                fetch(`${API_BASE_URL}/api/setlist?setlistId=2`).then((res) => res.json()),
                fetch(`${API_BASE_URL}/api/setlist?setlistId=3`).then((res) => res.json()),
            ]);
            setPrintSetlists({
                setlist1: results[0],
                setlist2: results[1],
                setlist3: results[2],
            });
        } catch (err) {
            alert("Error fetching print setlists");
            console.error(err);
        } finally {
            setLoadingPrintSetlists(false);
        }
    };

    const handlePreviewClick = () => {
        fetchPrintSetlists();
        setShowPreview(true);
    };

    const handleConfirmPrint = () => {
        window.print();
        setShowPreview(false);
    };

    // Gather all songs across all setlists for filtering master list
    const allSetlistSongs = [
        ...(printSetlists.setlist1 || []),
        ...(printSetlists.setlist2 || []),
        ...(printSetlists.setlist3 || []),
    ];

    if (loading) return <p>Loading setlist...</p>;
    if (error) return <p style={{ color: "red" }}>Error: {error}</p>;

    return (
        <div className="">
            <AdminMenu setIsAuthenticated={setIsAuthenticated} />
            <div className="edit-songlist">
            <h1>Setlist Creator</h1>
            <p>Add songs below to the setlist</p>
            {/* Add new song form */}
            <form onSubmit={addSongToMasterList} style={{ marginBottom: 20 }}>
                <input
                    type="text"
                    placeholder="Artist (optional)"
                    value={newArtist}
                    onChange={(e) => setNewArtist(e.target.value)}
                    style={{ padding: 8, marginRight: 10, width: "35%" }}
                />
                <input
                    type="text"
                    placeholder="Song Title"
                    value={newSongTitle}
                    onChange={(e) => setNewSongTitle(e.target.value)}
                    style={{ padding: 8, marginRight: 10, width: "40%" }}
                    required
                />
                <button type="submit" disabled={addingSong}>
                    {addingSong ? "Adding..." : "Add Song"}
                </button>
                </form>
                <div style={{display: "flex",justifyContent: "space-between",alignItems: "center",gap: "16px", marginTop: "20px",}}>
                <p>Drag songs from the left list into your setlist on the right.</p>
                {/* Preview / print */}
                {!showPreview && (
                    <button
                        onClick={handlePreviewClick}
                        style={{
                            marginTop: "20px",
                            padding: "10px 16px",
                            cursor: "pointer",
                            backgroundColor: "#0d6efd",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                        }}
                    >
                        Preview 3 Setlists Side by Side
                    </button>
                    )}
                </div>
            {/* Setlist selector */}
            <label htmlFor="setlist-select">Choose a setlist: </label>
            <select
                id="setlist-select"
                value={setlistId}
                onChange={(e) => setSetlistId(Number(e.target.value))}
                style={{ marginBottom: 20, marginLeft: 20, width:120, borderRadius:4 }}
            >
                <option value={1}>Set 1</option>
                <option value={2}>Set 2</option>
                <option value={3}>Set 3</option>
            </select>

            <DragDropContext onDragEnd={onDragEnd}>
                <div style={{ display: "flex", gap: 20 }}>
                    {/* Master list */}
                    <Droppable droppableId="masterList" isDropDisabled>
                        {(provided) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                style={{
                                    flex: 1,
                                    border: "1px solid #ccc",
                                    borderRadius: 4,
                                    padding: 10,
                                    backgroundColor: "#222",
                                    minHeight: 400,
                                }}
                            >
                                <h3>All Songs</h3>
                                {masterSongs
                                    .filter(
                                        song =>
                                            !allSetlistSongs.some(
                                                s => s.songTitle === song.songTitle && s.artist === song.artist
                                            )
                                    )
                                    .map((song, index) => (
                                        <Draggable
                                            key={song.id.toString()}
                                            draggableId={`master-${song.id}`}
                                            index={index}
                                        >
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={{
                                                        padding: 8,
                                                        marginBottom: 4,
                                                        backgroundColor: "#444",
                                                        borderRadius: 4,
                                                        color: "#fff",
                                                        ...provided.draggableProps.style,
                                                    }}
                                                >
                                                    {song.songTitle} {song.artist ? `- ${song.artist}` : ""}
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>

                    {/* Current setlist */}
                    <Droppable droppableId="setlist">
                        {(provided) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                style={{
                                    flex: 1,
                                    border: "1px solid #ccc",
                                    borderRadius: 4,
                                    padding: 10,
                                    backgroundColor: "#333",
                                    minHeight: 400,
                                }}
                            >
                                <h3>{setlistOptions[setlistId]}</h3>
                                {setlist.map((song, index) => (
                                    <Draggable
                                        key={song.id.toString()}
                                        draggableId={song.id.toString()}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    padding: 8,
                                                    marginBottom: 4,
                                                    backgroundColor: "#555",
                                                    borderRadius: 4,
                                                    color: "#fff",
                                                    ...provided.draggableProps.style,
                                                }}
                                            >
                                                <span>{song.songTitle}</span>
                                                <input
                                                    type="checkbox"
                                                    checked={song.tracks || false}
                                                    onChange={() => toggleTrack(song.id)}
                                                />
                                                <button
                                                    onClick={() => removeFromSetlist(song.id)}
                                                    style={{
                                                        marginLeft: 10,
                                                        backgroundColor: "#d9534f",
                                                        color: "white",
                                                        border: "none",
                                                        padding: "4px 8px",
                                                        borderRadius: 3,
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    &times;
                                                </button>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </div>
            </DragDropContext>

           

            {/*{showPreview && (*/}
            {/*    <button*/}
            {/*        onClick={handleConfirmPrint}*/}
            {/*        style={{*/}
            {/*            marginTop: "20px",*/}
            {/*            padding: "10px 16px",*/}
            {/*            cursor: "pointer",*/}
            {/*            backgroundColor: "green",*/}
            {/*            color: "white",*/}
            {/*            border: "none",*/}
            {/*            borderRadius: "4px",*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        Print This Preview*/}
            {/*    </button>*/}
            {/*)}*/}


            {/*{showPreview && !loadingPrintSetlists && (*/}
            {/*    <PrintSetlists*/}
            {/*        setlist1={printSetlists.setlist1}*/}
            {/*        setlist2={printSetlists.setlist2}*/}
            {/*        setlist3={printSetlists.setlist3}*/}
            {/*    />*/}
            {/*)}*/}

            {loadingPrintSetlists && <p>Loading print setlists...</p>}

            </div>
            {showPreview && (
                <div className="modal-overlay">
                    <div className="modal-content modal-large">
                        <div className="modal-header">
                            <h3>Setlist Preview</h3>
                            <button
                                className="modal-close"
                                onClick={() => setShowPreview(false)}
                            >
                                &times;
                            </button>
                        </div>

                        <div className="modal-body">
                            {loadingPrintSetlists ? (
                                <p>Loading print setlists...</p>
                            ) : (
                                <PrintSetlists
                                    setlist1={printSetlists.setlist1}
                                    setlist2={printSetlists.setlist2}
                                    setlist3={printSetlists.setlist3}
                                />
                            )}
                        </div>

                        <div className="modal-footer">
                            <button
                                onClick={handleConfirmPrint}
                                className="print-button"
                            >
                                Print
                            </button>
                            <button
                                onClick={() => setShowPreview(false)}
                                className="cancel-button"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};

export default Setlist;
